import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";
import { isBillableAgencyLink } from "@src/api/organization-agency-links/organization-agency-link-utils";

export const useHasBillableAgencyLink = () => {
  const orgSummary = useGetOrganizationSummary();
  return orgSummary.data?.org?.agencies?.some(isBillableAgencyLink) ?? false;
};
